import { createContext } from "react";
const UserSelectedPostContext = createContext({});

export default UserSelectedPostContext;
